import { render, staticRenderFns } from "./CategoriesReorder.vue?vue&type=template&id=27920f0d&scoped=true&"
import script from "./CategoriesReorder.vue?vue&type=script&lang=js&"
export * from "./CategoriesReorder.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesReorder.vue?vue&type=style&index=0&id=27920f0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27920f0d",
  null
  
)

export default component.exports